 <template>
    <!-- 商户进件详情 -->
    <div class="merchantNetInfoUpdate">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <el-form
            :inline="true"
            :model="agentForm"
            ref="agentForm"
            label-position="left"
        >
                <!-- 资质信息 -->
                <template>
                    <div class="m-title">照片信息<span style="color:red;margin-left:20px;">请确认信息无误后提交,并联系客服!</span></div>
                    <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等...." style="display: flex;">
                        <el-form-item label="法人身份证正面照" prop="card_positive_img" class='img_path'>
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleFrontIdCardImg"
                            >
                                <img
                                    v-if="agentForm.card_positive_img_path != ''"
                                    :src="agentForm.card_positive_img_path"
                                    class="avatar">
                                <img
                                    v-else
                                    :src="require('../../assets/images/idcard_f3x.png')"
                                    class="avatar">
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="法人身份证反面照" prop="card_negative_img" class='img_path'>
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleBackIdCardImg"
                            >
                                <img
                                    v-if="agentForm.card_negative_img_path != ''"
                                    :src="agentForm.card_negative_img_path"
                                    class="avatar">
                                <img
                                    v-else
                                    :src="require('../../assets/images/idcard_r3x.png')"
                                    class="avatar">
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="手持身份证照" prop="card_hand_hold_img" class='img_path'>
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleHandHoldImg"
                            >
                                <img
                                    v-if="agentForm.card_hand_hold_img_path != ''"
                                    :src="agentForm.card_hand_hold_img_path"
                                    class="avatar">
                                <img
                                    v-else
                                    :src="require('../../assets/images/other3x.png')"
                                    class="avatar">
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="结算卡照片" prop="settle_card_img" class='img_path' >
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleSettleImg"
                            >
                                <img
                                    v-if="agentForm.settle_card_img_path != ''"
                                    :src="agentForm.settle_card_img_path"
                                    class="avatar">
                                <img
                                    v-else
                                    :src="require('../../assets/images/other3x.png')"
                                    class="avatar">
                            </el-upload>
                        </el-form-item>
                    </div>
                </template>
                <!-- 资质信息 -->
                <template >
                    <div class="m-title">资料信息<span style="color:red;margin-left:20px;">请确认信息无误后提交,并联系客服!</span></div>
                    <el-form-item label="银行账户名称" prop="settle_acc_name">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.settle_acc_name"
                            placeholder="请输入银行账户名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="银行名称" prop="settle_bank_name">
                        <el-select
                            size="medium"
                            v-model="agentForm.settle_bank_name"
                            filterable
                            @change="handleBankChange"
                            placeholder="请选择银行名称"
                        >
                            <el-option
                                v-for="item in bankList"
                                :label="item.bank_name"
                                :value="item.bank_name"
                                :key="item.bank_name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="银行账号" prop="settle_acc_no">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.settle_acc_no"
                            placeholder="请输入银行账号"
                        ></el-input>
                    </el-form-item>
                </template>
                <template >
                    <el-form-item label="证件有效期" prop="owner_cert_sdate">
                        <el-date-picker
                            v-model="cardRange"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            :disabled="isSelect"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="handleCardChange"
                        ></el-date-picker>
                        <span style="margin-left:10px">
                            <el-checkbox
                                :true-label="1"
                                :false-label="0"
                                :disabled="agentForm.owner_cert_sdate == ''"
                                @change="handleCheckboxChange"
                                v-model="agentForm.is_long_time"
                            >长期</el-checkbox>
                        </span>
                    </el-form-item>
                </template>
                <template >
                    <div class="m-title">地址信息<span style="color:red;margin-left:20px;">请确认信息无误后提交,并联系客服!</span></div>
                    <el-form-item label="商户经营地址">
                        <el-cascader
                            separator="-"
                            filterable
                            :options="areaList"
                            :props="cascaderProps"
                            placeholder="请选择商户经营地址"
                            @change="handleAreaChange"
                        ></el-cascader>
                        &nbsp;&nbsp;&nbsp;<span style="font-size:12px">{{agentForm.view_business_addr}}-</span>
                    </el-form-item>

                    <el-form-item label="" prop="addr_detail">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.addr_detail"
                            placeholder="请输入详细地址"
                        ></el-input>
                    </el-form-item>
                </template>
        </el-form>
            <div style="margin-top:20px">
                <el-button
                    type="primary"
                    :loading="loading"
                    style="font-size: 12px;"
                    @click="handleSubmit(agentForm)"
                >提交资料</el-button>
                <el-button
                        type="primary"
                        :loading="loading"
                        style="font-size: 12px;"
                        @click="handleSnSubmit(agentForm)"
                >查询商户状态</el-button>
            </div>
    </div>
</template>

<script>
import imageViwe from '../../../node_modules/element-ui/packages/image/src/image-viewer';
import areaList from '../../utils/area';
import searchRegion from '../../utils/searchRegion';
export default {

    data() {
        return {
            loading: false, // 提交loading
            uploadUrl: this.$api.uploadUrl, // 上传图片的地址
            imgLoading: false, // 上传图片loading
            bankList: [], // 银行列表
            merchanttype: '',
            cardRange: [], // 身份证有效期
            isSelect: false, // 根据是否选中长期来判断身份证截止日期是否可选
            areaList, // 省市区数据
            cascaderProps: { // 省市区指定属性
                value: 'areaCode',
                label: 'areaName'
            },
            agentForm: {
                card_hand_hold_img: '', // 手持身份证 照片
                card_hand_hold_img_path: '', // 手持身份证 照片--展示
                settle_card_img: '', // 结算卡照片
                settle_card_img_path: '', // 结算卡照片--展示
                card_positive_img: '', // 身份证正面
                card_positive_img_path: '', // 身份证正面--展示
                card_negative_img: '', // 身份证反面
                card_negative_img_path: '', // 身份证反面--展示
                settle_acc_name: '', // 账户名
                settle_bank_name: '', // 银行id
                settle_acc_no: '', // 银行卡号
                is_long_time:0,
                owner_cert_sdate: '', // 身份证开始时间
                owner_cert_edate: '', // 身份证结束时间
                prov_code:"",//省
                city_code:"",//市
                area_code:"",//区
                view_business_addr:'',//省市区
                addr_detail:"",//详细地址
                union_pay_code:"",//地区码
                main_id:this.$route.query.id,//地区码
                owner_cert_id:"",
            },
        }
    },
    created() {
        this.getBank(); //获取银行列表
    },
    mounted() {
        this.merchanttype = this.$route.query.merchant_type; //取商户类型
        this.$api.post('merchant_net/getInfo', { id: this.$route.query.id, merchant_type: this.$route.query.merchant_type }, res => { //初始化
            let data = res.data;
            if (res.code == 0) {
                this.agentForm.card_hand_hold_img_path=data.card_hand_hold_photo;
                this.agentForm.settle_card_img_path=data.settle_card_photo;
                this.agentForm.card_positive_img_path=data.card_positive_photo;
                this.agentForm.card_negative_img_path=data.card_negative_photo;

                this.agentForm.settle_acc_name=data.settle_acc_name;
                this.agentForm.settle_bank_name=data.settle_bank_name;
                this.agentForm.settle_acc_no=data.settle_acc_no;

                this.agentForm.owner_cert_sdate=data.owner_cert_sdate;
                this.agentForm.owner_cert_edate=data.owner_cert_edate;

                this.agentForm.prov_code=data.prov_code;
                this.agentForm.city_code=data.city_code;
                this.agentForm.area_code=data.area_code;
                this.agentForm.union_pay_code=data.union_pay_code;
                this.agentForm.view_business_addr=data.view_business_addr;
                this.agentForm.addr_detail=data.addr_detail;
                this.agentForm.owner_cert_id=data.owner_cert_id;
                
                this.cardRange = [data.owner_cert_sdate,data.owner_cert_edate];
                if(data.owner_cert_edate=="9999-01-01"){
                    this.agentForm.is_long_time=1;
                    this.isSelect = true;
                }
            } else {
                this.$message.error(res.msg);
            }
        })
    },
    methods: {
        handleSubmit(agentForm) { //后台提交
            this.$refs.agentForm.validate(valid => {
                if (valid) {
                    this.loading = true; //防重复
                    this.$api.post('merchant/uploadphoto', agentForm, res => {
                        let that = this;
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: res.data,
                                duration: 1500,
                                onClose() {
                                    that.loading = false;
                                }
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg,
                                duration: 1500,
                                onClose() {
                                    that.loading = false;
                                }
                            });
                        }
                    })
                }
            })
        },
        handleSnSubmit(agentForm) { //后台提交
            this.$refs.agentForm.validate(valid => {
                if (valid) {
                    this.loading = true; //防重复
                    this.$api.post('merchant/merchantQuery', {id:agentForm.main_id}, res => {
                        let that = this;
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: res.data,
                                duration: 1500,
                                onClose() {
                                    that.loading = false;
                                }
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg,
                                duration: 1500,
                                onClose() {
                                    that.loading = false;
                                }
                            });
                        }
                    })
                }
            })
        },
        // 处理归属地区数据
        handleAreaChange(array) { 
            this.agentForm.prov_code = array[0].toString().substring(0,6);
            this.agentForm.city_code = array[1].toString().substring(0,6);
            this.agentForm.area_code = array[2].toString().substring(0,6);
            var bank_prov='';
            var bank_city='';
            var bank_area='';
            this._.forEach(searchRegion, (item, index) => {
                if (array[0].toString().substring(0,6) == item.code) {
                    bank_prov = item.name;
                    return;
                }
                if (array[1].toString().substring(0,6) == item.code) {
                    bank_city = item.name;
                    return;
                }
                if (array[2].toString().substring(0,6) == item.code) {
                    this.agentForm.union_pay_code = item.union_pay_code;
                    bank_area = item.name;
                    return;
                }
            })
            this.agentForm.view_business_addr=bank_prov+"-"+bank_city+"-"+bank_area;
        },
        getBank() { // 获取银行列表
            this.$api.post("bank/list", {}, res => {
                if (res.code == 0) {
                    this.bankList = res.data;
                }
            })
        },
        handleBankChange(bankVal) { // 处理银行选中时获取值
            let bank = this.bankList.filter(item => {
                return item.id == bankVal;
            });
            this.bankSign = bank[0].bank_symbol;
            if (this.agentForm.bank_prov) { //银行和省不为空的情况选择银行可取支行
                this.getBranch();
            }
        },
        handleCheckboxChange(value) { // 处理是否长期
            if (value == 1) {
                this.isSelect = true;
                if (this.cardRange.length) { // 已选择有效期后进行修改
                    this.cardRange = [this.cardRange[0], '9999-01-01'];
                    this.agentForm.owner_cert_edate = '9999-01-01';
                }
            } else {
                this.isSelect = false;
                if (this.cardRange.length) {
                    this.cardRange = [this.cardRange[0], this.$moment(Date.now()).format('YYYY-MM-DD')];
                    this.agentForm.owner_cert_edate = '';
                }
            }
        },
        handleImgLoading() { // 上传文件时加载loading
            this.imgLoading = true;
        },
        handleHandHoldImg(res) { // 手持证件照
            this.upImg({
                res,
                path: 'card_hand_hold_img',
                img: 'card_hand_hold_img_path'
            });
        },
        handleSettleImg(res) { // 结算卡
            this.upImg({
                res,
                path: 'settle_card_img',
                img: 'settle_card_img_path'
            });
        },
        handleFrontIdCardImg(res) { // 身份证正面
            this.upImg({
                res,
                path: 'card_positive_img',
                img: 'card_positive_img_path'
            });
        },
        handleBackIdCardImg(res) { // 身份证反面
            this.upImg({
                res,
                path: 'card_negative_img',
                img: 'card_negative_img_path'
            });
        },
        upImg(res) { //公用
            let resData = res.res;
            if (resData.code === 0) {
                this.agentForm[res.img] = resData.data.file_url; //展示路径
                this.agentForm[res.path] = resData.data.file_path //请求路径
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
            this.imgLoading = false;
        },
        handleCardChange(dateArr) { // 身份证有效期处理
            if (dateArr) {
                this.agentForm.owner_cert_sdate = dateArr[0];
                this.agentForm.owner_cert_edate = dateArr[1];
            }
        },
    }
}
</script>

<style scoped lang="scss">
.merchantNetInfoUpdate {
    font-size: 12px;
    .el-form-item {
        margin-bottom: 22px;
    }
    .m-title {
        color: #303133;
        font-size: 14px;
        font-weight: 700;
        padding-left: 10px;
        margin: 10px 0;
        border-left: 4px solid #409eff;
    }
    .img_path{
        width: 25%;
        display: grid;
    }
    .line {
        text-align: center;
    }
    ::v-deep .el-input-group__append {
        color: #ffffff;
        font-size: 12px;
        background-color: #409eff;
    }

    .avatar-uploader {
        width: 200px;
        height: 130px;
        border-radius: 10px;
        overflow: hidden;
    }
    ::v-deep .avatar-uploader .el-upload {
        width: 100%;
        height: 100%;
    }
    .avatar {
        width: 100%;
        height: 100%;
    }
}
</style>